export default __webpack_public_path__ + "static/media/67.3a1d1567.jpg";